import Quill from 'quill';

export const setupQuillConfig = () => {
  const FontAttributor = Quill.import('attributors/class/font');
  FontAttributor.whitelist = ['system'];
  Quill.register(FontAttributor, true);
};
